
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        // IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './GatesDataServiceEntities.g';

    
    function ecomGateSyncServiceQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function ecomGateSyncServiceInput (
        salesOrder:
            Entities.SalesOrder
    ): IDataServiceRequest {
      const query = ecomGateSyncServiceQuery();
      return query.createDataServiceRequestForOperation(
          'EcomGateSyncService',
          true, 
            ''
          ,
          'false',
          { bypassCache: 'get', returnEntity: '' },
          {
          salesOrder: salesOrder
          }
      );
    }

    export function ecomGateSyncServiceAsync (
        context: IContext, salesOrder:
            Entities.SalesOrder
        ): AsyncResult<string> {
        const request = ecomGateSyncServiceInput(salesOrder);
        return callActionOrExecute<string>(request, context.callerContext);
        }
      
    function startSyncServiceQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function startSyncServiceInput (
        
    ): IDataServiceRequest {
      const query = startSyncServiceQuery();
      return query.createDataServiceRequestForOperation(
          'StartSyncService',
          true, 
            ''
          ,
          'false',
          { bypassCache: 'get', returnEntity: '' },
          {
          
          }
      );
    }

    export function startSyncServiceAsync (
        context: IContext
        ): AsyncResult<string> {
        const request = startSyncServiceInput();
        return callActionOrExecute<string>(request, context.callerContext);
        }
      

        // @ts-ignore
        function payRowQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("PayRow", "VSICategoryEXT", DataServiceEntities.VSICategoryEXTExtensionClass, key);
        }

        
    export function createPayRowPurchaseInput(payRowPurchaseResquest: DataServiceEntities.IPayRowPurchaseResquest): IDataServiceRequest {
    const query = payRowQuery();
    return query.createDataServiceRequestForOperation('PayRowPurchase', true, DataServiceEntities.PayRowPurchaseResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IPayRowPurchaseResponse'}, {payRowPurchaseResquest: payRowPurchaseResquest });
    }

    
    export function payRowPurchaseAsync(context: IContext, payRowPurchaseResquest: DataServiceEntities.IPayRowPurchaseResquest): AsyncResult<DataServiceEntities.IPayRowPurchaseResponse> {
    const request = createPayRowPurchaseInput(payRowPurchaseResquest);
    return callActionOrExecute<DataServiceEntities.IPayRowPurchaseResponse>(request, context.callerContext);
    }
  
    export function createPayRowInquiryInput(payRowInquiryRequest: DataServiceEntities.IPayRowInquiryVoidRefundRequest): IDataServiceRequest {
    const query = payRowQuery();
    return query.createDataServiceRequestForOperation('PayRowInquiry', true, DataServiceEntities.PayRowInquiryResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IPayRowInquiryResponse'}, {payRowInquiryRequest: payRowInquiryRequest });
    }

    
    export function payRowInquiryAsync(context: IContext, payRowInquiryRequest: DataServiceEntities.IPayRowInquiryVoidRefundRequest): AsyncResult<DataServiceEntities.IPayRowInquiryResponse> {
    const request = createPayRowInquiryInput(payRowInquiryRequest);
    return callActionOrExecute<DataServiceEntities.IPayRowInquiryResponse>(request, context.callerContext);
    }
  
    export function createPayRowVoidInput(payRowVoidRequest: DataServiceEntities.IPayRowInquiryVoidRefundRequest): IDataServiceRequest {
    const query = payRowQuery();
    return query.createDataServiceRequestForOperation('PayRowVoid', true, DataServiceEntities.PayRowVoidResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IPayRowVoidResponse'}, {payRowVoidRequest: payRowVoidRequest });
    }

    
    export function payRowVoidAsync(context: IContext, payRowVoidRequest: DataServiceEntities.IPayRowInquiryVoidRefundRequest): AsyncResult<DataServiceEntities.IPayRowVoidResponse> {
    const request = createPayRowVoidInput(payRowVoidRequest);
    return callActionOrExecute<DataServiceEntities.IPayRowVoidResponse>(request, context.callerContext);
    }
  